import { FETCH_RECEIPT, FETCH_RECEIPT_SUCCESS } from '../constants';
import config from '../../config';
import { checkStatus, handleRequestError } from '../utils/helpers';

export const getReceipt = (id, transactionId) => (
  fetch(`${config.url}/pos/receipt/${id}/${transactionId}`).then(checkStatus)
);

// eslint-disable-next-line import/prefer-default-export
export const fetchReceipt = (id, transactionIdentifier) => (dispatch) => {
  dispatch({ type: FETCH_RECEIPT });
  return getReceipt(id, transactionIdentifier)
    .then((response) => {
      if (response.shop.logo) {
        const shopLogo = new Image();
        shopLogo.src = response.shop.logo.url;
        shopLogo.onload = () => {
          dispatch({ type: FETCH_RECEIPT_SUCCESS, payload: response });
        };
      } else {
        dispatch({ type: FETCH_RECEIPT_SUCCESS, payload: response });
      }
    })
    .catch(handleRequestError(dispatch));
};



// WEBPACK FOOTER //
// ./src/app/receipt/actions.js